import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-gray-200 last:border-0" data-id="element-46">
      <button className="w-full py-6 flex justify-between items-center text-left focus:outline-none group" onClick={onClick} data-id="element-47">
        <span className="text-lg font-bold text-deep-blue group-hover:text-mint-dark transition-colors" data-id="element-48">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-deep-blue/50 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-49" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 opacity-100 pb-6' : 'max-h-0 opacity-0'}`} data-id="element-50">
        <p className="text-deep-blue/70 leading-relaxed" data-id="element-51">{answer}</p>
      </div>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Funciona con adolescentes?',
    answer: 'Sí. Aunque los ejemplos del manual están orientados a niños de 3 a 12 años, la neuro-regulación es universal. Solo tendrás que adaptar el lenguaje a su nivel de madurez.'
  }, {
    question: '¿Tengo que dejarle llorar o ignorarle?',
    answer: 'Jamás. El Protocolo Cero Gritos es un método 100% respetuoso basado en la conexión, no en el castigo ni en la indiferencia.'
  }, {
    question: '¿Cuánto tardaré en ver resultados?',
    answer: 'Esta misma tarde notarás el cambio. Al cambiar tu forma de abordar la desconexión de la pantalla, su respuesta biológica cambia instantáneamente.'
  }, {
    question: '¿Es un pago único o una suscripción?',
    answer: 'Es un pago único de 6,95€. Sin cuotas ocultas ni suscripciones. Tendrás acceso para siempre al material y a sus futuras actualizaciones.'
  }];
  return <section className="py-10 px-4 bg-white" data-id="element-52">
      <div className="max-w-3xl mx-auto" data-id="element-53">
        <div className="text-center mb-6" data-id="element-54">
          <h2 className="text-3xl md:text-4xl font-bold text-deep-blue mb-4" data-id="element-55">
            Preguntas Frecuentes
          </h2>
          <p className="text-deep-blue/60" data-id="element-56">
            Resolvemos tus dudas antes de entrar.
          </p>
        </div>

        <div className="bg-cream rounded-3xl p-6 md:p-10" data-id="element-57">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-58" />)}
        </div>
      </div>
    </section>;
}